import React from 'react';
import {
	NavLink,
	Link
} from 'react-router-dom'


class Footer extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		let options = this.props.options;
		options = options.options ? options.options : {};
		return (
			Object.keys(options).length &&
				<section className="section fp-auto-height">
					<footer>
						<div className="main-container">
							<div className="grid">
								<figure className="ll-flogo">
									<img src={options.logo_image} alt="Le Lay Architects" title="Le Lay Architects" />
								</figure>
								<div className="grid">
									<div>
										<p>{options.office_details}</p>
										<div dangerouslySetInnerHTML={{__html:options.office_address}} />
										<p className="mb-20"><a href={`mailto:${options.contact_email}`}>{options.contact_email}</a></p>
										<p><a href={`tel:+${options.contact_number}`}>{options.contact_number}</a></p>
										<p><a href={options.twitter_url} target="_blank">LinkedIn</a> / <a href={options.instagram_url} target="_blank">Instagram</a></p>
									</div>
									<div>
										<div dangerouslySetInnerHTML={{__html:options.copyright }} />
										<div dangerouslySetInnerHTML={{__html:options.logos }} />
									</div>
								</div>
							</div>
						</div>
					</footer>
				</section>
		);
	}
}
export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js